const SECTION_EXPORT_PHRASE = {
  contracts: "по контракту",
  addresses: "по адресам",
  complexes: "по комплексам",
};

const exportTypes = {
  locations: {
    label: "Задача на выгрузку адресов",
  },
  user_log_export: {
    label: "Задача на выгрузку логов",
  },
  statistic_export: {
    label: "Задача на выгрузку статистики с главной страницы",
  },
  report_export: {
    label: "Задача на выгрузку проездов",
  },
  sensors: {
    label: "Задача на выгрузку комплексов",
  },
  user_documents: {
    label: "Задача на выгрузку документов",
  },
};

/** Human-readable label for user_documents export jobs. */
export const getUserDocumentsExportName = ({ section, documentTypeName } = {}) => {
  const sectionPhrase = SECTION_EXPORT_PHRASE[section];
  const typeName = String(documentTypeName || "").trim();

  if (sectionPhrase && typeName) {
    return `Задача на выгрузку документов ${sectionPhrase} (${typeName})`;
  }
  if (sectionPhrase) {
    return `Задача на выгрузку документов ${sectionPhrase}`;
  }
  if (typeName) {
    return `Задача на выгрузку документов (${typeName})`;
  }
  return "Задача на выгрузку документов";
};

/**
 * Resolve display name for an export job row.
 * Backend keeps title empty — build from request.section + document type map.
 * @param {object} item
 * @param {Record<string, string>} [documentTypeNamesById] id -> type name
 */
export const getExportJobTypeLabel = (item, documentTypeNamesById = {}) => {
  if (!item) return "";

  const explicit = String(item.title || "").trim();
  if (explicit) return explicit;

  if (item.type === "user_documents") {
    const request = item.request || {};
    const typeId = String(request.document_type_id || item.document_type_id || "").trim();
    const documentTypeName =
      (typeId && documentTypeNamesById[typeId]) ||
      request.document_type_name ||
      item.document_type_name ||
      "";

    return getUserDocumentsExportName({
      section: request.section || item.section,
      documentTypeName,
    });
  }

  return exportTypes[item.type]?.label || item.type || "";
};

export default exportTypes;
